export enum enumVoyageType {
  COLOADING,
  FULL_CONTAINER,
}
